import { render, staticRenderFns } from "./ComplaintPage.vue?vue&type=template&id=787b7e7c&"
import script from "./ComplaintPage.vue?vue&type=script&lang=js&"
export * from "./ComplaintPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports